<template lang="pug">
.v-page-404.page-404(v-if="page404")
	img.page-404__image(:src="page404.image" alt="")
	.page-404__container.container
		.page-404__wrap
			.page-404__right
				.page-404__main
					.page-404__supertitle(v-if="page404.supertitle") {{page404.supertitle}}
					.page-404__title.flc(v-if="page404.title") {{page404.title}}
				.page-404__footer
					.page-404__text(v-if="page404.text") {{page404.text}}
					.page-404__description.flc(v-if="page404.description") {{page404.description}}
					.page-404__action.flc(v-if="page404.link")
						a.main-banner__link.btn.btn--has-right-icon.btn--primary.btn--wide-sm(:href="page404.link.link")
							.btn__text {{page404.link.text}}
							.btn__icon-wrap
								v-svg-icon.btn__icon.btn__icon--original(icon="arrow-top-right")
								v-svg-icon.btn__icon.btn__icon--copy(icon="arrow-top-right")
</template>

<script>
import sourceMixin from '../components/mixins/v-mixin-source.vue';
import controller from "../scripts/controller/controller.js";

export default {
	mixins: [
		sourceMixin
	],

	data() {
		return {
			page404: null
		};
	},

	unmounted() {
		window.removeEventListener('scroll', this.handleScroll);
	},

	methods: {
		handleScroll() {
			const logoHeight = 80;
			const logoOffset = 48;
			if (window.scrollY > this.$el?.offsetTop - 48 && (window.scrollY < this.$el.offsetHeight + this.$el.offsetTop + logoHeight - logoOffset)) {
				document.body.classList.remove('state--page-header-blackout');
			}
		},

		dataSet(data) {
			this.page404 = data;
			this.handleScroll();
			window.addEventListener('scroll', this.handleScroll, controller.passiveEventsSupported ? {passive: true} : undefined);
		}
	}
};
</script>
